import {Component, input, output, ChangeDetectionStrategy} from "@angular/core"
import {ButtonComponent} from "@common/components/buttons/button/button.component"

export type TemplateViewType = "edit" | "image" | "configurator"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-template-view-type-selector",
    templateUrl: "./template-view-type-selector.component.html",
    styleUrl: "./template-view-type-selector.component.scss",
    imports: [ButtonComponent],
})
export class TemplateViewTypeSelectorComponent {
    readonly $viewType = input.required<TemplateViewType>({alias: "viewType"})

    readonly viewTypeChanged = output<TemplateViewType>()
}
